import { render } from "./my-environment.vue?vue&type=template&id=2f946e9f&scoped=true&ts=true&lang=pug"
import script from "./my-environment.vue?vue&type=script&lang=ts"
export * from "./my-environment.vue?vue&type=script&lang=ts"

import "./my-environment.vue?vue&type=style&index=0&id=2f946e9f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f946e9f"]])

export default __exports__